import { useAppSelector } from '../../../hooks/redux'
import { Strings } from '../../../constants/Strings'
import { Colors } from '../../../constants/Colors'
import style from '../../../rootStyles/Options.module.css'
import HeaderRight from '../../../components/HeaderRight/HeaderRight'
import NavBar from './NavBar/NavBar'

const Options = () => {
    
    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)

    return (
        <div
            className={style.container}
            style={{
                backgroundColor: Colors[theme ?? 'light'].secondBackground
            }}
        >
            <HeaderRight
                icon={null}
                title={Strings[language ?? 'tm'].pages}
            />
            <div
                className={style.content}
                style={{
                    borderLeft: `1px solid ${Colors[theme ?? 'light'].borderLight}`
                }}
            >
                <NavBar />
            </div>
        </div>
    )
}

export default Options